import StaticIndex from './static-index';
import ScrollSectionsFixed from '../../helpers/scroll-sections-fixed';

export default class StaticIndexDesktop extends StaticIndex {
    constructor(...args) {
        super(...args);
    }

    _retrieveDOM() {
        super._retrieveDOM();

        this.dom.views.summaryParent = this.dom.page.querySelector('.js-summary-parent');
        this.dom.views.summarys = this.dom.page.querySelectorAll('.js-summary');
        this.dom.views.sectionsParent = this.dom.page.querySelector('.js-section-parent');
        this.dom.views.sectionsContent = this.dom.page.querySelectorAll('.js-section-content');
    }

    init() {
        super.init();

        if( this.dom.views.summarys && this.dom.views.summarys.length > 0 ) {

            this.ScrollSectionsFixed = new ScrollSectionsFixed({
                dom: {
                    summary: {
                        parent: this.dom.views.summaryParent,
                        items: this.dom.views.summarys
                    },
                    sections: {
                        parent: this.dom.views.sectionsParent,
                        items: this.dom.views.sectionsContent
                    }
                },
                params: {
                    hasDuration: true
                }
            });
        }
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/static/static-index.desktop.js